import { FormCard, RowConfig } from 'design-system';
import React from 'react';
import { strings } from 'strings';

interface WarningProps {
  setIsHidden: (isHidden: boolean) => void;
}

export const SearchWarningCard: React.FC<WarningProps> = ({ setIsHidden }) => {
  const warningMessages = [
    strings.PatientSearchWarningItem1,
    strings.PatientSearchWarningItem2,
    strings.PatientSearchWarningItem3,
  ];

  const messageRow: RowConfig[] = [
    {
      icon: 'warning',
      fields: [
        {
          type: 'list',
          label: strings.PatientSearchWarningLabel,
          display: warningMessages,
        },
      ],
    },
  ];

  const onEditPress = () => {
    setIsHidden(true);
  };

  return (
    <FormCard
      cardColor="status-warning"
      showIcons={true}
      title={strings.PatientSearchWarningTitle}
      rows={messageRow}
      onButtonPress={onEditPress}
      buttonText={strings.PatientSearchWarningButtonTitle}
      buttonIcon="close"
    />
  );
};
